import {
  AnalyticsDocument,
  EventDetailsOutputDocument,
} from '@/types/graphql/types'
import { useMutation, useQuery } from '@apollo/client'
import { parseInt } from 'lodash'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

const useEvent = () => {
  const { query } = useRouter()
  //fetch event data
  const { data } = useQuery(EventDetailsOutputDocument, {
    variables: { eventDetailsOutputId: parseInt(query.id as string) },
  })
  //Analytics mutation
  const [mutate] = useMutation(AnalyticsDocument)
  useEffect(() => {
    if (typeof window !== 'undefined')
      mutate({ variables: { data: { url: window.location.href } } })
  }, [mutate])

  return {
    data,
  }
}

export default useEvent
